import {initDetailByAPI} from '@web/actions/detail'
import {PurchaseRewardAdmin} from '@web/slices/reward/slice'
import makeSlice from '@web/slices/reward/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {productOrders, order, pay} = payload.data

            state.products = productOrders.map((product) => {
                return {
                    itemId: product.productOrderNo,
                    imageUrl: product.productImageUrl ?? null,
                    name: product.productName,
                    largeCategoryId: product.largeCategoryId,
                    middleCategoryId: product.middleCategoryId,
                    smallCategoryId: product.smallCategoryId,
                    serviceType: order.serviceType,
                    merchantNo: product.merchantNo.toString(),
                    naverBenefit: product.naverBenefit,
                    productOrderStatusType: product.productOrderStatusType,
                    payAmountInfo: {
                        productAmount: product.orderAmount,
                        totalPayAmount: pay.totalInitPayAmount,
                        totalPointPayAmount: pay.rewardPointPayAmount,
                        scheduledChannelTypeCode: order.scheduledChannelType ?? null,
                        rentalOrderClassCode: order.rental?.rentalOrderClassType ?? null,
                        initOrderTotalPromotionApplyAmount: pay.promotionApplyAmount ?? null,
                    },
                    writtenReview: product.reviewWritten ?? false,
                    ...(product.optionContents &&
                        product.orderQuantity && {
                            optionInfo: {
                                contents: product.optionContents,
                                quantity: product.orderQuantity,
                            },
                        }),
                }
            })
            state.paymentStatus = productOrders.some(
                ({productOrderStatusType}) => productOrderStatusType === 'PURCHASE_DECIDED',
            )
                ? 'purchaseDecided'
                : 'expected'

            state.purchaseRewardPoint.total.adminAdditional.adminType = order.rental?.contractNo
                ? PurchaseRewardAdmin.RENTAL
                : order.subscription?.subscriptionRound
                  ? PurchaseRewardAdmin.SUBSCRIPTION
                  : PurchaseRewardAdmin.DEFAULT

            state.benefitCardRewardTid = pay.benefitCardRewardTid ?? null
            state.rentalGiftPoint = order.rental?.rentalGiftPoint ?? 0
        })
    },
})

export default slice.reducer
